import { render, staticRenderFns } from "./notice-board.vue?vue&type=template&id=451310d0&scoped=true"
import script from "./notice-board.vue?vue&type=script&lang=js"
export * from "./notice-board.vue?vue&type=script&lang=js"
import style0 from "./notice-board.vue?vue&type=style&index=0&id=451310d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451310d0",
  null
  
)

export default component.exports